import { render } from "./AnexoStatusSelect.vue?vue&type=template&id=30b8d6cf"
import script from "./AnexoStatusSelect.vue?vue&type=script&lang=js"
export * from "./AnexoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__